import { BaseTxProviderSchemaValues } from '@lp/features/RoutePlanner/components/RouteLegForm/validation';
import { useAsyncSearchableList } from '@/hooks/useAsyncSearchableList';
import { useInfiniteTXCentersProvidersListQuery } from '@/queries/txcenter-providers';
import { ProviderSelect } from './ProviderSelect';

export const TxCenterProviderSelect = () => {
  const { list: txCenterProvidersList } = useAsyncSearchableList({ query: useInfiniteTXCentersProvidersListQuery });

  return (
    <ProviderSelect<BaseTxProviderSchemaValues>
      providerFieldName="txCenterProviderId"
      providerInputTitle="TX Center Provider"
      providerList={txCenterProvidersList}
    />
  );
};
